import PropTypes from 'prop-types';
import React from 'react';

import { calculatePrice, productUrl, productImage } from '@snapbrains/snapav/src/avantlink';
import { simpleWidth, simpleHeight, simpleFontSize } from '../../utils/settings_builder';
import Merchant from './parts/merchant';
import SaleTag, { saleTagColor } from './parts/sale_tag';
import Price from './parts/price';

function getStyles(options, settings) {
  const fontSize = settings.fontSize || simpleFontSize;
  const styles = {
    container: {
      float: 'left',
      display: 'block',
      width: options.width,
      padding: '10px 5px',
      textAlign: 'center',
      margin: 5,
      color: settings.textColor,
    },
    imageContainer: {
      height: options.height,
      width: '100%',
      textAlign: 'center',
      backgroundImage: `url("${options.image}")`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
    },
    imageLink: {
      cursor: 'pointer',
      height: options.height,
      width: '100%',
      display: 'block',
    },
    titleContainer: {
      height: 32,
      overflow: 'hidden',
      textAlign: 'center',
      margin: '4px 0',
      width: '100%',
    },
    title: {
      lineHeight: '1.1em',
      fontSize,
      color: settings.textColor,
      cursor: 'pointer',
    },
    button: {
      color: settings.buttonColor,
      backgroundColor: settings.darkColor,
      display: 'inline-block',
      fontSize,
      padding: '3px 15px',
      textAlign: 'center',
      cursor: 'pointer',
      textDecoration: 'none',
      borderRadius: 3,
    },
    buttonContainer: {
      textAlign: 'center',
    },
    priceContainer: {
      textAlign: 'center',
      margin: '5px 0',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    saleTagContainer: {
      position: 'relative',
    },
    saleTag: {
      backgroundColor: settings.saleTagColor,
      color: '#FFF',
      top: 0,
      right: -10,
      padding: '2px 10px',
      position: 'absolute',
      fontWeight: 100,
      fontSize: fontSize - 2,
    },
    salePrice: {
      margin: '0 10px',
      textDecoration: 'line-through',
      textDecorationColor: settings.saleTagColor || saleTagColor,
    },
    merchantContainer: {
      textAlign: 'center',
      marginBottom: 5,
    },
    merchantLink: {
      fontSize: fontSize - 4,
      color: settings.textColor,
      textDecoration: 'none',
    },
  };

  if (settings.backgroundColor) {
    styles.container.backgroundColor = settings.backgroundColor;
  }

  if (settings.borderColor) {
    styles.container.border = `solid 1px ${settings.borderColor}`;
  }

  return styles;
}

export default function ResultSimple(props) {
  const { result, settings } = props;
  const url = productUrl(
    result,
    settings.avantlinkWebsiteId,
    settings.trackingCode,
    settings.appId,
  );
  const width = settings.width || simpleWidth;
  const height = settings.height || simpleHeight;
  const image = productImage(result, width, height);
  const calculatedPricing = calculatePrice(result);
  const buttonText = settings.buttonText || 'More Info';
  const target = settings.openNewWindow ? '_blank' : '_self';

  const styles = getStyles({ image, width, height }, settings);

  return (
    <div style={styles.container}>
      <SaleTag styles={styles} calculatedPricing={calculatedPricing} />
      <div style={styles.imageContainer}>
        <a href={url} target={target} rel="nofollow noreferrer" style={styles.imageLink}>&nbsp;</a>
      </div>
      <div style={styles.titleContainer}>
        <a href={url} target={target} style={styles.title}>
          {result.strProductName}
        </a>
      </div>
      <Price
        styles={styles}
        result={result}
        calculatedPricing={calculatedPricing}
      />
      <Merchant
        display={settings.displayMerchant}
        styles={styles}
        url={url}
        target={target}
        result={result}
      />
      <div style={styles.buttonContainer}>
        <a target={target} href={url} rel="nofollow noreferrer" className="snapgadget-btn" style={styles.button}>{buttonText}</a>
      </div>
    </div>
  );
}

ResultSimple.propTypes = {
  settings: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    buttonText: PropTypes.string,
    appId: PropTypes.number,
    avantlinkWebsiteId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    trackingCode: PropTypes.string,
    openNewWindow: PropTypes.bool,
    displayMerchant: PropTypes.bool,
  }).isRequired,
  result: PropTypes.shape({
    strProductName: PropTypes.string,
  }).isRequired,
};
